import { render, staticRenderFns } from "./Internalusers.vue?vue&type=template&id=6365011f&scoped=true"
import script from "./Internalusers.vue?vue&type=script&lang=ts"
export * from "./Internalusers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365011f",
  null
  
)

export default component.exports